import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../../Profile/Accounts_react/AccountsUtils';
import Input from '../../../Input/InputView';
import {
  descriptionValidator,
  amountValidator,
  yearValidator,
} from '../../LargePurchaseWorkflowValidators';

const ItemDescription = ({
  workflowId,
  branch,
  clientId,
  store,
  itemDescription,
  onPostSave,
  onPostProcess,
  purchaseAmount,
  isNew,
  goal,
  purchaseYear,
  purchaseYearOptions,
  largePurchaseGoals,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.Name`} />

    <h2>What would you like to purchase?</h2>

    <AdvForm>
      <ul className="horizontal">
        <li>
          <Input
            isUnder
            type="text"
            id="adv-item-description"
            placeholder="Item Description"
            className="md text-center"
            value={itemDescription}
            onChange={inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Name`)}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={descriptionValidator(itemDescription, largePurchaseGoals, goal ? goal.Id : '')}
      validationId={`${BACKEND_KEY}.Name`}
      doNotSave={
        yearValidator(purchaseYear, purchaseYearOptions)().length > 0 ||
        amountValidator(purchaseAmount)().length > 0
      }
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      onPostSave={onPostSave(isNew, workflowId, clientId)}
      onPostProcess={onPostProcess(goal)}
    />
  </AdvWorkflowStep>
);

ItemDescription.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  purchaseAmount: PropTypes.number.isRequired,
  itemDescription: PropTypes.string.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  goal: PropTypes.shape().isRequired,
  onPostSave: PropTypes.func.isRequired,
  isNew: PropTypes.bool.isRequired,
  purchaseYear: PropTypes.number.isRequired,
  purchaseYearOptions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  largePurchaseGoals: PropTypes.arrayOf(
    PropTypes.shape({
      Name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ItemDescription;
